module.exports = __webpack_public_path__ + "static/island-hopping-545a2a554e6a6973fedf5a6e857fea25.mp4";